document.addEventListener("wheel", (e) => { if (e.target.type === "number") e.target.blur() }, {passive: true})
document.addEventListener("keydown", (e) => { if (e.target.type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) e.preventDefault() }, true)
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("form").forEach(form => {
        /**
         * Initializes event handlers for numeric inputs.
         * Attaches handlers to all enabled, editable number inputs.
         */
        const attachNumericInputHandlers = () => {
            const numberInputs = form.querySelectorAll('[type="number"]:not([disabled]):not([readonly])')

            numberInputs.forEach(input => {
                input.addEventListener("keypress", handleKeyPress)
                input.addEventListener("paste", handlePaste)
                input.addEventListener("blur", sanitizeInput)
            })
        }

        /**
         * Prevents invalid characters from being typed into a number input.
         *
         * @param {KeyboardEvent} event - The keyboard event.
         */
        const handleKeyPress = (event) => {
            const {key, target} = event

            // Allow numeric digits or a single dot (if not already present in the input)
            if (!isDigit(key) && !isDot(key)) {
                event.preventDefault()
                return
            }

            if (isDot(key) && target.value.includes(".")) {
                event.preventDefault()
            }
        }

        /**
         * Prevents invalid characters from being pasted into a number input.
         *
         * @param {ClipboardEvent} event - The clipboard event.
         */
        const handlePaste = (event) => {
            const {clipboardData, target} = event
            const pastedValue = clipboardData.getData("text")

            // Block paste if the content is not a valid numeric value
            if (!isValidNumber(pastedValue)) {
                event.preventDefault()
                return
            }

            // Block paste if it introduces multiple dots
            if (target.value.includes(".") && pastedValue.includes(".")) {
                event.preventDefault()
            }
        }

        /**
         * Cleans up and formats the input value when the user leaves the input field.
         *
         * @param {FocusEvent} event - The blur event.
         */
        const sanitizeInput = (event) => {
            const {target} = event
            let value = target.value.trim()

            // Clear the input if it's zero, empty, or invalid
            if (isNaN(Number(value))) {
                target.value = ""
                return
            }

            if (target.classList.contains("clear-zero") && Number(value) === 0){
                target.value = ""
                return
            }

            // Add "0" prefix if the value starts with a dot (e.g., ".5" -> "0.5")
            if (value.startsWith(".")) value = `0${value}`

            // Remove the decimal point if the value is a whole number
            value = Number(value)
            if (value % 1 === 0) {
                value = Math.trunc(value).toString()
            } else {
                value = value.toFixed(2)
            }

            target.value = value
        }

        /**
         * Checks if a character is a valid numeric digit (0-9).
         *
         * @param {string} char - The character to check.
         * @returns {boolean} True if the character is a digit, false otherwise.
         */
        const isDigit = (char) => /\d/.test(char)

        /**
         * Checks if a character is a dot (decimal point).
         *
         * @param {string} char - The character to check.
         * @returns {boolean} True if the character is a dot, false otherwise.
         */
        const isDot = (char) => char === "."

        /**
         * Validates whether a string is a valid numeric input.
         * Supports numbers with or without a decimal point.
         *
         * @param {string} value - The value to validate.
         * @returns {boolean} True if the value is a valid numeric input, false otherwise.
         */
        const isValidNumber = (value) => /^(\d+(\.\d{0,2})?|\.\d{1,2})$/.test(value)

        const observer = new MutationObserver(() => {
            attachNumericInputHandlers()
        })

        observer.observe(form, {childList: true, subtree: true})

        // Attach handlers to numeric inputs once the DOM is fully loaded
        attachNumericInputHandlers()
    })
})
